/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var BuildingType;
(function (BuildingType) {
    BuildingType["ResidentialBuildings"] = "ResidentialBuildings";
    BuildingType["Hotel"] = "Hotel";
    BuildingType["AdministrativeBuildings"] = "AdministrativeBuildings";
    BuildingType["Hospital"] = "Hospital";
    BuildingType["EducationalInstitutions"] = "EducationalInstitutions";
    BuildingType["PreschoolEducationalInstitutions"] = "PreschoolEducationalInstitutions";
})(BuildingType || (BuildingType = {}));
export var CategoryClass;
(function (CategoryClass) {
    CategoryClass["General"] = "General";
    CategoryClass["A"] = "A";
    CategoryClass["B"] = "B";
    CategoryClass["C"] = "C";
})(CategoryClass || (CategoryClass = {}));
export var ConstructionClass;
(function (ConstructionClass) {
    ConstructionClass["Wall"] = "Wall";
    ConstructionClass["Floor"] = "Floor";
})(ConstructionClass || (ConstructionClass = {}));
export var ConstructionPosition;
(function (ConstructionPosition) {
    ConstructionPosition["Left"] = "Left";
    ConstructionPosition["Center"] = "Center";
    ConstructionPosition["Right"] = "Right";
})(ConstructionPosition || (ConstructionPosition = {}));
export var ConstructionTypeEnum;
(function (ConstructionTypeEnum) {
    ConstructionTypeEnum["HeavySingleLayerWall"] = "HeavySingleLayerWall";
    ConstructionTypeEnum["HeavySingleLayerWallFacingOneSide"] = "HeavySingleLayerWallFacingOneSide";
    ConstructionTypeEnum["HeavySingleLayerWallFacingBothSide"] = "HeavySingleLayerWallFacingBothSide";
    ConstructionTypeEnum["HeavySingleLayerWallZPanelOneSide"] = "HeavySingleLayerWallZPanelOneSide";
    ConstructionTypeEnum["HeavySingleLayerWallZPanelBothSide"] = "HeavySingleLayerWallZPanelBothSide";
    ConstructionTypeEnum["HeavyMultipleLayerWall"] = "HeavyMultipleLayerWall";
    ConstructionTypeEnum["HeavyMultipleLayerWallFacingOneSide"] = "HeavyMultipleLayerWallFacingOneSide";
    ConstructionTypeEnum["HeavyMultipleLayerWallFacingBothSide"] = "HeavyMultipleLayerWallFacingBothSide";
    ConstructionTypeEnum["HeavyMultipleLayerWallZPanelOneSide"] = "HeavyMultipleLayerWallZPanelOneSide";
    ConstructionTypeEnum["HeavyMultipleLayerWallZPanelBothSide"] = "HeavyMultipleLayerWallZPanelBothSide";
    ConstructionTypeEnum["OneFramePartition"] = "OneFramePartition";
    ConstructionTypeEnum["TwoFramePartition"] = "TwoFramePartition";
    ConstructionTypeEnum["HeavySingleWallFacing"] = "HeavySingleWallFacing";
})(ConstructionTypeEnum || (ConstructionTypeEnum = {}));
export var CountryType;
(function (CountryType) {
    CountryType["None"] = "None";
    CountryType["Albania"] = "Albania";
    CountryType["Andorra"] = "Andorra";
    CountryType["Austria"] = "Austria";
    CountryType["Belarus"] = "Belarus";
    CountryType["Belgium"] = "Belgium";
    CountryType["BosniaAndHerzegovina"] = "BosniaAndHerzegovina";
    CountryType["Bulgaria"] = "Bulgaria";
    CountryType["Croatia"] = "Croatia";
    CountryType["Cyprus"] = "Cyprus";
    CountryType["CzechRepublic"] = "CzechRepublic";
    CountryType["Denmark"] = "Denmark";
    CountryType["Estonia"] = "Estonia";
    CountryType["Finland"] = "Finland";
    CountryType["France"] = "France";
    CountryType["Germany"] = "Germany";
    CountryType["Greece"] = "Greece";
    CountryType["Hungary"] = "Hungary";
    CountryType["Iceland"] = "Iceland";
    CountryType["Ireland"] = "Ireland";
    CountryType["Italy"] = "Italy";
    CountryType["Latvia"] = "Latvia";
    CountryType["Lithuania"] = "Lithuania";
    CountryType["Luxembourg"] = "Luxembourg";
    CountryType["Malta"] = "Malta";
    CountryType["Moldova"] = "Moldova";
    CountryType["Monaco"] = "Monaco";
    CountryType["Montenegro"] = "Montenegro";
    CountryType["Netherlands"] = "Netherlands";
    CountryType["NorthMacedonia"] = "NorthMacedonia";
    CountryType["Norway"] = "Norway";
    CountryType["Poland"] = "Poland";
    CountryType["Portugal"] = "Portugal";
    CountryType["Romania"] = "Romania";
    CountryType["Russia"] = "Russia";
    CountryType["SanMarino"] = "SanMarino";
    CountryType["Serbia"] = "Serbia";
    CountryType["Slovakia"] = "Slovakia";
    CountryType["Slovenia"] = "Slovenia";
    CountryType["Spain"] = "Spain";
    CountryType["Sweden"] = "Sweden";
    CountryType["Switzerland"] = "Switzerland";
    CountryType["Ukrain"] = "Ukrain";
})(CountryType || (CountryType = {}));
export var IndexType;
(function (IndexType) {
    IndexType["Rw"] = "Rw";
    IndexType["Lnw"] = "Lnw";
    IndexType["Value\u0394Rw"] = "\u0394Rw";
})(IndexType || (IndexType = {}));
export var MaterialOriginType;
(function (MaterialOriginType) {
    MaterialOriginType["Generic"] = "Generic";
    MaterialOriginType["Manufacturer"] = "Manufacturer";
    MaterialOriginType["UserDefinedProduct"] = "UserDefinedProduct";
})(MaterialOriginType || (MaterialOriginType = {}));
export var MaterialParametrs;
(function (MaterialParametrs) {
    MaterialParametrs["Thickness"] = "Thickness";
    MaterialParametrs["Density"] = "Density";
    MaterialParametrs["ConnectionNumber"] = "ConnectionNumber";
    MaterialParametrs["RackStep"] = "RackStep";
    MaterialParametrs["Width"] = "Width";
})(MaterialParametrs || (MaterialParametrs = {}));
export var MaterialTypeEnum;
(function (MaterialTypeEnum) {
    MaterialTypeEnum["MasonryAndSolid"] = "MasonryAndSolid";
    MaterialTypeEnum["Frame"] = "Frame";
    MaterialTypeEnum["PorousMaterials"] = "PorousMaterials";
    MaterialTypeEnum["SandwichPanel"] = "SandwichPanel";
    MaterialTypeEnum["GypsumBondedbBoards"] = "GypsumBondedbBoards";
    MaterialTypeEnum["WoodBasedBoard"] = "WoodBasedBoard";
    MaterialTypeEnum["MineralBondedBoards"] = "MineralBondedBoards";
    MaterialTypeEnum["Metal"] = "Metal";
    MaterialTypeEnum["Glazing"] = "Glazing";
    MaterialTypeEnum["Membrane"] = "Membrane";
    MaterialTypeEnum["FoamMaterials"] = "FoamMaterials";
    MaterialTypeEnum["AcousticTreatmentMaterials"] = "AcousticTreatmentMaterials";
    MaterialTypeEnum["AirGap"] = "AirGap";
    MaterialTypeEnum["Link"] = "Link";
    MaterialTypeEnum["Filler"] = "Filler";
    MaterialTypeEnum["Heavy"] = "Heavy";
    MaterialTypeEnum["Board"] = "Board";
    MaterialTypeEnum["ZPanel"] = "ZPanel";
})(MaterialTypeEnum || (MaterialTypeEnum = {}));
export var Priority;
(function (Priority) {
    Priority["Zero"] = "Zero";
    Priority["One"] = "One";
    Priority["Two"] = "Two";
    Priority["Three"] = "Three";
    Priority["Four"] = "Four";
    Priority["Five"] = "Five";
    Priority["Six"] = "Six";
    Priority["Seven"] = "Seven";
    Priority["Eight"] = "Eight";
    Priority["Nine"] = "Nine";
    Priority["Ten"] = "Ten";
})(Priority || (Priority = {}));
export var PurposeBuilding;
(function (PurposeBuilding) {
    PurposeBuilding["LargePanelBuilding"] = "LargePanelBuilding";
    PurposeBuilding["FramePanelBuilding"] = "FramePanelBuilding";
})(PurposeBuilding || (PurposeBuilding = {}));
export var ReportCategory;
(function (ReportCategory) {
    ReportCategory["Floor"] = "Floor";
    ReportCategory["Single"] = "Single";
})(ReportCategory || (ReportCategory = {}));
export var ReportInfoStatus;
(function (ReportInfoStatus) {
    ReportInfoStatus["InProgress"] = "InProgress";
    ReportInfoStatus["Completed"] = "Completed";
})(ReportInfoStatus || (ReportInfoStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "Asc";
    SortOrder["Desc"] = "Desc";
})(SortOrder || (SortOrder = {}));
import axios from 'axios';
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
var HttpClient = /** @class */ (function () {
    function HttpClient(_a) {
        if (_a === void 0) { _a = {}; }
        var _this = this;
        var securityWorker = _a.securityWorker, secure = _a.secure, format = _a.format, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = function (data) {
            _this.securityData = data;
        };
        this.request = function (_a) { return __awaiter(_this, void 0, void 0, function () {
            var secureParams, _b, requestParams, responseFormat;
            var secure = _a.secure, path = _a.path, type = _a.type, query = _a.query, format = _a.format, body = _a.body, params = __rest(_a, ["secure", "path", "type", "query", "format", "body"]);
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (typeof secure === 'boolean' ? secure : this.secure) &&
                            this.securityWorker;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.securityWorker(this.securityData)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        secureParams = (_b) ||
                            {};
                        requestParams = this.mergeRequestParams(params, secureParams);
                        responseFormat = format || this.format || undefined;
                        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
                            body = this.createFormData(body);
                        }
                        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
                            body = JSON.stringify(body);
                        }
                        return [2 /*return*/, this.instance.request(__assign(__assign({}, requestParams), { headers: __assign(__assign({}, (requestParams.headers || {})), (type ? { 'Content-Type': type } : {})), params: query, responseType: responseFormat, data: body, url: path }))];
                }
            });
        }); };
        this.instance = axios.create(__assign(__assign({}, axiosConfig), { baseURL: axiosConfig.baseURL || '' }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    HttpClient.prototype.mergeRequestParams = function (params1, params2) {
        var method = params1.method || (params2 && params2.method);
        return __assign(__assign(__assign(__assign({}, this.instance.defaults), params1), (params2 || {})), { headers: __assign(__assign(__assign({}, ((method &&
                this.instance.defaults.headers[method.toLowerCase()]) ||
                {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    };
    HttpClient.prototype.stringifyFormItem = function (formItem) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return "".concat(formItem);
        }
    };
    HttpClient.prototype.createFormData = function (input) {
        var _this = this;
        if (input instanceof FormData) {
            return input;
        }
        return Object.keys(input || {}).reduce(function (formData, key) {
            var property = input[key];
            var propertyContent = property instanceof Array ? property : [property];
            for (var _i = 0, propertyContent_1 = propertyContent; _i < propertyContent_1.length; _i++) {
                var formItem = propertyContent_1[_i];
                var isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : _this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    };
    return HttpClient;
}());
export { HttpClient };
/**
 * @title Acoustics.API
 * @version 1.0
 */
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    function Api() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = {
            /**
             * No description
             *
             * @tags Account
             * @name AccountRegisterCreate
             * @request POST:/api/Account/register
             */
            accountRegisterCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Account/register", method: 'POST', body: data, type: ContentType.FormData }, params));
            },
            /**
             * No description
             *
             * @tags Account
             * @name AccountCurrentList
             * @request GET:/api/Account/current
             */
            accountCurrentList: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Account/current", method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Account
             * @name AccountUpdateUpdate
             * @request PUT:/api/Account/update
             */
            accountUpdateUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Account/update", method: 'PUT', body: data, type: ContentType.FormData }, params));
            },
            /**
             * No description
             *
             * @tags Article
             * @name ArticleDetail
             * @request GET:/api/Article/{id}
             */
            articleDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Article/".concat(id), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Article
             * @name ArticleDelete
             * @request DELETE:/api/Article/{id}
             */
            articleDelete: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Article/".concat(id), method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Article
             * @name ArticleGetPaginatedCreate
             * @request POST:/api/Article/getPaginated
             */
            articleGetPaginatedCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Article/getPaginated", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Article
             * @name ArticleCreate
             * @request POST:/api/Article
             */
            articleCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Article", method: 'POST', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Article
             * @name ArticleUpdate
             * @request PUT:/api/Article
             */
            articleUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Article", method: 'PUT', body: data, type: ContentType.FormData }, params));
            },
            /**
             * No description
             *
             * @tags Auth
             * @name AuthLoginCreate
             * @request POST:/api/Auth/login
             */
            authLoginCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Auth/login", method: 'POST', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Auth
             * @name AuthRefreshCreate
             * @request POST:/api/Auth/refresh
             */
            authRefreshCreate: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Auth/refresh", method: 'POST' }, params));
            },
            /**
             * No description
             *
             * @tags Auth
             * @name AuthLogoutCreate
             * @request POST:/api/Auth/logout
             */
            authLogoutCreate: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Auth/logout", method: 'POST' }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionDetail
             * @request GET:/api/Construction/{ConstructionHeaderId}
             */
            constructionDetail: function (constructionHeaderId, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction/".concat(constructionHeaderId), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionConstructionTypesList
             * @request GET:/api/Construction/ConstructionTypes
             */
            constructionConstructionTypesList: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction/ConstructionTypes", method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionGetPaginatedCreate
             * @request POST:/api/Construction/get-paginated
             */
            constructionGetPaginatedCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction/get-paginated", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionCreate
             * @request POST:/api/Construction
             */
            constructionCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionDelete
             * @request DELETE:/api/Construction
             */
            constructionDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionUpdate
             * @request PUT:/api/Construction
             */
            constructionUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction", method: 'PUT', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Construction
             * @name ConstructionAlternativeConstructionsCreate
             * @request POST:/api/Construction/alternativeConstructions
             */
            constructionAlternativeConstructionsCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Construction/alternativeConstructions", method: 'POST', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Graph
             * @name GraphDetail
             * @request GET:/api/Graph/{constructionHeaderId}
             */
            graphDetail: function (constructionHeaderId, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Graph/".concat(constructionHeaderId), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Issuer
             * @name IssuerDetail
             * @request GET:/api/Issuer/{id}
             */
            issuerDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Issuer/".concat(id), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Issuer
             * @name IssuerGetPaginatedCreate
             * @request POST:/api/Issuer/get-paginated
             */
            issuerGetPaginatedCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Issuer/get-paginated", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Issuer
             * @name IssuerCreate
             * @request POST:/api/Issuer
             */
            issuerCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Issuer", method: 'POST', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Issuer
             * @name IssuerDelete
             * @request DELETE:/api/Issuer
             */
            issuerDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Issuer", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Issuer
             * @name IssuerUpdate
             * @request PUT:/api/Issuer
             */
            issuerUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Issuer", method: 'PUT', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Material
             * @name MaterialDetail
             * @request GET:/api/Material/{id}
             */
            materialDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Material/".concat(id), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Material
             * @name MaterialGetPaginatedCreate
             * @request POST:/api/Material/get-paginated
             */
            materialGetPaginatedCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Material/get-paginated", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Material
             * @name MaterialCreate
             * @request POST:/api/Material
             */
            materialCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Material", method: 'POST', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Material
             * @name MaterialDelete
             * @request DELETE:/api/Material
             */
            materialDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Material", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Material
             * @name MaterialUpdate
             * @request PUT:/api/Material
             */
            materialUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Material", method: 'PUT', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags MaterialType
             * @name MaterialTypeList
             * @request GET:/api/MaterialType
             */
            materialTypeList: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/MaterialType", method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags PlacementRoomVariants
             * @name PlacementRoomVariantsCreate
             * @request POST:/api/PlacementRoomVariants
             */
            placementRoomVariantsCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/PlacementRoomVariants", method: 'POST', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags PlacementRoomVariants
             * @name PlacementRoomVariantsGetSecondRoomCreate
             * @request POST:/api/PlacementRoomVariants/get-second-room
             */
            placementRoomVariantsGetSecondRoomCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/PlacementRoomVariants/get-second-room", method: 'POST', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportInfoCreate
             * @request POST:/api/ReportInfo
             */
            reportInfoCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/ReportInfo", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportInfoDelete
             * @request DELETE:/api/ReportInfo
             */
            reportInfoDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/ReportInfo", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportInfoSingleDetail
             * @request GET:/api/ReportInfo/{id}/single
             */
            reportInfoSingleDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/ReportInfo/".concat(id, "/single"), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportInfoFloorDetail
             * @request GET:/api/ReportInfo/{id}/floor
             */
            reportInfoFloorDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/ReportInfo/".concat(id, "/floor"), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportInfoReportConstructionDetail
             * @request GET:/api/ReportInfo/{id}/reportConstruction
             */
            reportInfoReportConstructionDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/ReportInfo/".concat(id, "/reportConstruction"), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportInfoReportInfoFlagsDetail
             * @request GET:/api/ReportInfo/{id}/ReportInfoFlags
             */
            reportInfoReportInfoFlagsDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/ReportInfo/".concat(id, "/ReportInfoFlags"), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Requirement
             * @name RequirementDetail
             * @request GET:/api/Requirement/{id}
             */
            requirementDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Requirement/".concat(id), method: 'GET', format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Requirement
             * @name RequirementGetPaginatedCreate
             * @request POST:/api/Requirement/get-paginated
             */
            requirementGetPaginatedCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Requirement/get-paginated", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Requirement
             * @name RequirementCreate
             * @request POST:/api/Requirement
             */
            requirementCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Requirement", method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Requirement
             * @name RequirementDelete
             * @request DELETE:/api/Requirement
             */
            requirementDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Requirement", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Requirement
             * @name RequirementUpdate
             * @request PUT:/api/Requirement
             */
            requirementUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Requirement", method: 'PUT', body: data, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Sms
             * @name PostApi
             * @request POST:/api/Sms
             */
            postApi: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Sms", method: 'POST', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Sms
             * @name SmsApproveCreate
             * @request POST:/api/Sms/approve
             */
            smsApproveCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/Sms/approve", method: 'POST', body: data, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags SvgConstruction
             * @name SvgConstructionDetail
             * @request GET:/api/SvgConstruction/{id}
             */
            svgConstructionDetail: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/api/SvgConstruction/".concat(id), method: 'GET', format: 'json' }, params));
            },
        };
        _this.single = {
            /**
             * No description
             *
             * @tags ReportInfo
             * @name SingleUpdate
             * @request PUT:/single
             */
            singleUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/single", method: 'PUT', body: data, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.floor = {
            /**
             * No description
             *
             * @tags ReportInfo
             * @name DocumentUpdate
             * @request PUT:/floor/document
             */
            documentUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/floor/document", method: 'PUT', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ConstructionUpdate
             * @request PUT:/floor/construction
             */
            constructionUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/floor/construction", method: 'PUT', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ConstructionImageUpdate
             * @request PUT:/floor/construction/image
             */
            constructionImageUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/floor/construction/image", method: 'PUT', body: data, type: ContentType.FormData, format: 'json' }, params));
            },
        };
        _this.documentInfo = {
            /**
             * No description
             *
             * @tags ReportInfo
             * @name DocumentInfoUpdate
             * @request PUT:/documentInfo
             */
            documentInfoUpdate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/documentInfo", method: 'PUT', body: data, type: ContentType.FormData }, params));
            },
        };
        _this.floorConstruction = {
            /**
             * No description
             *
             * @tags ReportInfo
             * @name FloorConstructionDelete
             * @request DELETE:/floorConstruction
             */
            floorConstructionDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/floorConstruction", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
        };
        _this.reportConstruction = {
            /**
             * No description
             *
             * @tags ReportInfo
             * @name ReportConstructionDelete
             * @request DELETE:/reportConstruction
             */
            reportConstructionDelete: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reportConstruction", method: 'DELETE', body: data, type: ContentType.Json }, params));
            },
        };
        return _this;
    }
    return Api;
}(HttpClient));
export { Api };
